module.exports = __webpack_public_path__ + "img/img-1.3ce3b98b.png";